/**
 * Trạng thái sắp xếp
 */
export default {
  /**
   * Không sort
   */
  none: 0,
  /**
   * Giảm dần
   */
  desc: 2,
  /**
   * Tăng dần
   */
  asc: 1,
};
